/** Cookie identifiers shared by browser analytics and authenticated request helpers. */
export enum COOKIE_KEYS {
  ACCESS_TOKEN = "auth",
  COMPLIANCE_EXCLUSION_TAGS = "dream_cet",
  EXCLUDED_PROGRAM_IDS = "dream_excluded_program_ids",
  DREAMSEARCH_SESSION_ZIP = "dreamsearch_session_zip",
  EVERFLOW_AFFILIATE_PARAMS = "db_ef_affiliate_params",
  EXPERIMENTS = "dream_experiments",
  FB_PIXEL_BROWSER_ID = "_fbp",
  FB_PIXEL_CLICK_ID = "_fbc",
  FORM_FUNNEL_ID = "dream_form_funnel_id",
  FUNNEL_EXPERIMENTS = "db_funnel_experiments",
  REFRESH_TOKEN = "refresh",
  INITIAL_REFERRER = "dream_initial_referrer",
  LANDING_URL = "dream_landing_url",
  LOGOUT = "dream_logout",
  GOOGLE_ADS_ATTRIBUTION = "db_google_ads_attribution",
  GOOGLE_ANALYTICS_CLIENT_ID = "_ga",
}
